import { Modal } from "react-bootstrap";
import { useApiMutation, refetch, onSuccess } from "../../utils/api";
import { ModalBase } from "../../utils/modal_launcher";
import { SimpleForm } from "../../utils/simple_form";

const AddIdeaModal = ({ close, tripId, groups }) => {
  const { post } = useApiMutation();

  const submit = (values) => {
    post(`/api/user/add_idea/${tripId}`, { idea: values }).then(
      onSuccess(() => {
        close();
        refetch("idea-board");
      })
    );
  };

  return (
    <ModalBase title="Add Idea" close={close}>
      <Modal.Body>
        <SimpleForm
          fields={{
            idea_type: {
              label: "Category",
              type: "select_creatable",
              placeholder: "Select or type a category",
              options: groups.map((group) => group.title),
              required: true,
            },
            title: { required: true },
            cost: {},
            link: {},
            image: { label: "Image URL" },
          }}
          onSubmit={submit}
          devToolValues={{ idea_type: "hotel", title: "Some Idea" }}
        />
      </Modal.Body>
    </ModalBase>
  );
};

export default AddIdeaModal;
